import React from "react";
import "./Content.css";

function Content () {
    return(
        <div className="container">
            <div className="row EmpContentHeader">
                <div className="col-2">
                    <span>Employee ID</span>
                </div>
                <div className="col-3 DCenter">
                    <span>Employee Name</span>
                </div>
                <div className="col-2 DCenter">
                    <span>Designation</span>
                </div>
                <div className="col-2 DCenter">
                    <span>Total Hours</span>
                </div>
                <div className="col-2 DCenter">
                    <span>Remarks</span>
                </div>
                <div className="col-1 DEnd">
                    <span>Action</span>
                </div>
            </div>
        </div>
    )
}

export default Content;